/*
  P97 — pay-in-4 line under "Subtotal" in the slide cart:
    or 4 interest-free payments of $X with Shop Pay

  (A shipping-rates row was tried here and removed at Marcos's call.)
  The pay-in-4
  amount is the subtotal / 4, only between $50 and $3,000 (Shop Pay
  Installments' range), recalculated whenever the cart changes. Checkout
  adds shipping and tax to the real split.

  Display only: reads /cart.js, never writes to the cart, never opens or closes
  the drawer, never touches udesly.
*/
(function () {
  'use strict';

  var BNPL_MIN = 50, BNPL_MAX = 3000;

  var css =
    '.p97cx{margin:0 0 12px;font-size:13px;line-height:1.35;color:#555}' +
    '.p97cx__row{display:flex;justify-content:space-between;align-items:baseline;gap:12px}' +
    '.p97cx__row + .p97cx__row{margin-top:4px}' +
    '.p97cx__val{color:#000;text-align:right}' +
    '.p97cx__bnpl{text-align:right;font-size:12.5px;color:#555}' +
    '.p97cx__bnpl b{color:#000;font-weight:600}' +
    '.p97cx__sp{color:#5a31f4;font-weight:700}' +
    '.p97cx [hidden]{display:none!important}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var subtotalCents = null;

  function money(c) {
    var n = Math.ceil(c) / 100;
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function build(footer) {
    var el = footer.querySelector('[data-p97cx]');
    if (el) return el;
    var line = footer.querySelector('.w-commerce-commercecartlineitem');
    if (!line) return null;
    el = document.createElement('div');
    el.className = 'p97cx';
    el.setAttribute('data-p97cx', '');
    el.innerHTML =
      '<div class="p97cx__bnpl" data-p97cx-bnpl hidden></div>';
    line.insertAdjacentElement('afterend', el);
    // tuck it right under the Subtotal amount, like a subline
    line.style.marginBottom = '2px';
    return el;
  }

  function paint() {
    document.querySelectorAll('.w-commerce-commercecartfooter').forEach(function (f) {
      var el = build(f);
      if (!el) return;
      var b = el.querySelector('[data-p97cx-bnpl]');
      if (subtotalCents != null && subtotalCents >= BNPL_MIN * 100 && subtotalCents <= BNPL_MAX * 100) {
        b.innerHTML = 'or 4 interest-free payments of <b>' + money(subtotalCents / 4) +
                      '</b> with <span class="p97cx__sp">Shop Pay</span>';
        b.hidden = false;
      } else {
        b.hidden = true;
      }
    });
  }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { busy = false; subtotalCents = c.items_subtotal_price; paint(); })
      .catch(function () { busy = false; });
  }

  function cartOpen() {
    var w = document.querySelectorAll('.w-commerce-commercecartcontainerwrapper');
    for (var i = 0; i < w.length; i++) if (getComputedStyle(w[i]).display !== 'none') return true;
    return false;
  }

  function start() {
    paint();
    refresh();
    // refresh often while the cart is open (quantities, removals), rarely otherwise
    var tick = 0;
    setInterval(function () {
      tick++;
      if (cartOpen() || tick % 8 === 0) refresh();
    }, 1000);
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (n) {
      document.addEventListener(n, refresh);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
